import { render } from "./DigitalDictList.vue?vue&type=template&id=58c7bbaf"
import script from "./DigitalDictList.vue?vue&type=script&lang=js"
export * from "./DigitalDictList.vue?vue&type=script&lang=js"

import "@/pages/admin/forum/css/antd.css?vue&type=style&index=0&lang=css"
import "./DigitalDictList.vue?vue&type=style&index=1&id=58c7bbaf&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__